import { Table, Space, Popconfirm, message, Tooltip } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import {
  useDeleteInterventionMutation,
  useGetInterventionByProjectQuery,
} from "../../store/is/interventionapi";
import moment from "moment";

interface Intervention {
  _id: string;
  name: string;
  methodology_id: string;
  description: string;
  created?: string | null;
  creator?: string;
  project_id: string;
}

const InterventionTable: React.FC<{ projectId: string }> = ({ projectId }) => {
  const {
    data: intervention = [],
    isFetching,
    refetch,
  } = useGetInterventionByProjectQuery(projectId);
  const [deleteIntervention] = useDeleteInterventionMutation();

  const formatCreatedDate = (dateString: string | null) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD MMM, YYYY @ HH:mm:ss");
  };

  const handleDelete = async (id: string) => {
    try {
      await deleteIntervention(id).unwrap();
      message.success("Intervention deleted successfully");
      refetch();
    } catch (err) {
      message.error("Failed to delete intervention");
      console.error(err);
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      render: (text: string) => (
        <div
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: "Methodology",
      dataIndex: "methodology_name",
      key: "methodology_name",
      width: 200,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
      render: (text: string) => (
        <Tooltip title={text} placement="topLeft">
          <div
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {text}
          </div>
        </Tooltip>
      ),
    },
    {
      title: "Created",
      dataIndex: "created",
      key: "created_at",
      width: 150,
      render: (date: string | null) => (date ? formatCreatedDate(date) : "N/A"),
    },
    {
      title: "Actions",
      key: "actions",
      width: 100,
      render: (_: any, record: Intervention) => (
        <Space size="middle">
          <Popconfirm
            title="Are you sure to delete this intervention?"
            onConfirm={() => handleDelete(record._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={intervention as any}
      rowKey="_id"
      loading={isFetching}
      pagination={{ pageSize: 10 }}
      scroll={{ x: true }}
      style={{ width: "100%" }}
    />
  );
};

export default InterventionTable;
